module.exports = __webpack_public_path__ + "img/nashville-worldwide.8b17bd0e.png";